<wbo-edit-page #editPage [title]="model.data.name" (addingAnother)="addingAnother($event)">
    <fui-rows [formGroup]="editPage.formGroup">
        <fui-row>
            <fui-two-columns>
                <fui-column>
                    <wbo-text-edit-control formControlName="name" [(ngModel)]="model.data.name">
                    </wbo-text-edit-control>
                </fui-column>
                <fui-column>
                    <wbo-single-select-edit-control formControlName="type" [(ngModel)]="model.data.type"
                                                    [allowClearSelectionOption]="false" [readonlyOnEdit]="true" (onSelect)="typeSelect()">
                        <wbo-terminal-type-select-options></wbo-terminal-type-select-options>
                    </wbo-single-select-edit-control>
                </fui-column>
            </fui-two-columns>
        </fui-row>
        <fui-row *ngIf="model.data.type === TerminalData.FUNCTIONAL_TYPE">
            <fui-two-columns formGroupName="functionalTerminal">
                <fui-column formGroupName="standardTerminal">
                    <wbo-terminal-single-select-edit-control formControlName="terminalId" [(ngModel)]="model.data.functionalTerminal.standardTerminal.terminalId" [typeFilter]="TerminalData.STANDARD_TYPE">
                    </wbo-terminal-single-select-edit-control>
                </fui-column>
                <fui-column>
                    <wbo-text-edit-control formControlName="terminalFunction" [(ngModel)]="model.data.functionalTerminal.terminalFunction">
                    </wbo-text-edit-control>
                </fui-column>
            </fui-two-columns>
        </fui-row>
        <fui-row>
            <fui-two-columns>
                <fui-column>
                    <wbo-screen-layout-single-select-edit-control formControlName="configurationId" [(ngModel)]="model.data.configurationId">
                    </wbo-screen-layout-single-select-edit-control>
                </fui-column>
                <fui-column formGroupName="functionBar">
                    <wbo-function-bar-single-select-edit-control formControlName="id" [objectValue]="model.data.functionBar" [(ngModel)]="model.data.functionBar.id">
                    </wbo-function-bar-single-select-edit-control>
                </fui-column>
            </fui-two-columns>
        </fui-row>
        <fui-row>
            <fui-two-columns>
                <fui-column formGroupName="outlet">
                    <wbo-outlet-single-select-edit-control formControlName="outletId" [objectValue]="model.data.outlet" [(ngModel)]="model.data.outlet.outletId">
                    </wbo-outlet-single-select-edit-control>
                </fui-column>
                <fui-column formGroupName="priceLevel">
                    <wbo-price-level-single-select-edit-control formControlName="priceLevelId" [objectValue]="model.data.priceLevel" [(ngModel)]="model.data.priceLevel.priceLevelId">
                    </wbo-price-level-single-select-edit-control>
                </fui-column>
            </fui-two-columns>
        </fui-row>
        <fui-row>
            <fui-two-columns>
                <fui-column>
                    <wbo-text-edit-control formControlName="orderNumberPrefix" [(ngModel)]="model.data.orderNumberPrefix">
                    </wbo-text-edit-control>
                </fui-column>
                <fui-column>
                    <wbo-textarea-edit-control formControlName="description" [(ngModel)]="model.data.description">
                    </wbo-textarea-edit-control>
                </fui-column>
            </fui-two-columns>
        </fui-row>
    </fui-rows>
</wbo-edit-page>
